package or.garden.manager.domain.model

import gardenmanager.composeapp.generated.resources.Res
import gardenmanager.composeapp.generated.resources.april
import gardenmanager.composeapp.generated.resources.august
import gardenmanager.composeapp.generated.resources.december
import gardenmanager.composeapp.generated.resources.february
import gardenmanager.composeapp.generated.resources.january
import gardenmanager.composeapp.generated.resources.july
import gardenmanager.composeapp.generated.resources.june
import gardenmanager.composeapp.generated.resources.march
import gardenmanager.composeapp.generated.resources.may
import gardenmanager.composeapp.generated.resources.november
import gardenmanager.composeapp.generated.resources.october
import gardenmanager.composeapp.generated.resources.september
import kotlinx.serialization.Serializable
import or.garden.manager.components.stringResource1
import or.garden.manager.domain.GardenHttpClient

@Serializable
open class SeedData(
    val id: Int,
    val userId: Int,
    val name: String,
    val latinName: String? = null,
    val hybrid: Boolean = false,
    val photo: String? = null,
    // new fields
    val type: String? = null,
    val harvestTime: Int? = null,
    val seedlingDate: String? = null,
    val backPhoto: String? = null
) {
    fun photoUrl(): String? {
        if (photo.isNullOrEmpty()) return null
        return GardenHttpClient.baseUrl + photo
    }

    fun backPhotoUrl(): String? {
        if (backPhoto.isNullOrEmpty()) return null
        return GardenHttpClient.baseUrl + backPhoto
    }

    fun seedlingDates(): String {
        return seedlingDate?.split(",")?.joinToString(", ") {
            when (it) {
                "1" -> stringResource1(Res.string.january)
                "2" -> stringResource1(Res.string.february)
                "3" -> stringResource1(Res.string.march)
                "4" -> stringResource1(Res.string.april)
                "5" -> stringResource1(Res.string.may)
                "6" -> stringResource1(Res.string.june)
                "7" -> stringResource1(Res.string.july)
                "8" -> stringResource1(Res.string.august)
                "9" -> stringResource1(Res.string.september)
                "10" -> stringResource1(Res.string.october)
                "11" -> stringResource1(Res.string.november)
                "12" -> stringResource1(Res.string.december)
                else -> ""
            }.take(3)
        } ?: ""
    }

    fun copy(
        id: Int = this.id,
        userId: Int = this.userId,
        name: String = this.name,
        latinName: String? = this.latinName,
        hybrid: Boolean = this.hybrid,
        photo: String? = this.photo,
        type: String? = this.type,
        harvestTime: Int? = this.harvestTime,
        seedlingDate: String? = this.seedlingDate,
        backPhoto: String? = this.backPhoto
    ): SeedData {
        return SeedData(
            id,
            userId,
            name,
            latinName,
            hybrid,
            photo,
            type,
            harvestTime,
            seedlingDate,
            backPhoto
        )
    }
}

class HeaderSeedData(name: String, latinName: String) : SeedData(
    id = -1,
    userId = -1,
    name = name,
    latinName = latinName,
    hybrid = false,
    photo = null
)